import { FILTER_TABLE, SET_INIT_TABLE_CONTENT } from '../constans';
import { AdminTable } from '../../utils/builder/IAdminPage';
import { setInitialSelectsValues } from './statisticsFilters';
import { TABLE_HEADER_INDEX } from '../../constans/statisticsTableConstants';

const createData = (tableData) => {
  const addElement = (object, key, element) => {
    if (!object[key]) {
      object[key] = [];
    }
    object[key].push(element);
  };

  return tableData.reduce(
    (currentValue, Row) => {
      const hub = Row[TABLE_HEADER_INDEX['HUB']];
      const project = Row[TABLE_HEADER_INDEX['PROJECT']];
      const model = Row[TABLE_HEADER_INDEX['MODEL']];

      addElement(currentValue.hub, '', hub);
      addElement(currentValue.project, hub, project);
      addElement(currentValue.model, project, model);

      return currentValue;
    },
    {
      hub: {},
      project: {},
      model: {},
    }
  );
};

export const setInitialTableContent = () => async (dispatch) => {
  const tableData = await AdminTable();
  const selectsOptionsDependsSchema = createData(tableData);
  dispatch({
    type: SET_INIT_TABLE_CONTENT,
    payload: { tableData },
  });
  dispatch(setInitialSelectsValues(selectsOptionsDependsSchema));
};

export const filterTable = (filtersValue) => async (dispatch) => {
  dispatch({
    type: FILTER_TABLE,
    payload: { filtersValue },
  });
};
